export const FEE_DIVISOR = 10_000;

export const ERROR_MESSAGES = {
    'E68: slippage error': 'Insufficient slippage. Please increase it and try again.',
};
